import { Product, KeyWordLandingPageCategory } from '../../../types';

export type MergedProductsWithCategories = KeyWordLandingPageCategory & {
  products: Product[];
};

export const mergeProductsWithCategories = (
  products: Product[],
  categories: KeyWordLandingPageCategory[]
) => {
  const productByCategoryMap = products.reduce((acc, product) => {
    const categoryId = product.category?.id;
    if (!categoryId) return acc;
    const productsInCategory = acc[categoryId] || [];
    return { ...acc, [categoryId]: [...productsInCategory, product] };
  }, {} as Record<string, Product[]>);

  // The category should have the same order as they appear in the facets
  const mergedProductsWithCategories = categories.reduce((acc, category) => {
    const productForCategory = productByCategoryMap[category.classicId];
    if (!productForCategory) {
      return acc;
    }
    return [...acc, { ...category, products: productForCategory }];
  }, [] as MergedProductsWithCategories[]);

  return mergedProductsWithCategories;
};
